import { render, staticRenderFns } from "./WorkbenchNav.vue?vue&type=template&id=1b5a8a50&scoped=true"
import script from "./WorkbenchNav.vue?vue&type=script&lang=js"
export * from "./WorkbenchNav.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchNav.vue?vue&type=style&index=0&id=1b5a8a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5a8a50",
  null
  
)

export default component.exports